import axios from "axios";
import { cmsHeaders, headers } from "../exports/exports";

export const fetchAboutBanner = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_cmsUrl}/content-manager/ega-banner?sort=sort_order:asc`,
      { headers: cmsHeaders },
    );
    return response.data;
  } catch (error) {
    console.error("Server Error");
  }
};

export const fetchvisionObjectiveHeader = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_cmsUrl}/content-manager/ega-vision-and-objective-header`,
      { headers: cmsHeaders },
    );
    return response.data.slice(-1);
  } catch (error) {
    console.error("Server Error");
  }
};

export const fetchvision = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_cmsUrl}/content-manager/ega-vision`,
      { headers: cmsHeaders },
    );
    return response.data.slice(-1);
  } catch (error) {
    console.error("Server Error");
  }
};

export const fetchobjective = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_cmsUrl}/content-manager/ega-objective`,
      { headers: cmsHeaders },
    );
    return response.data;
  } catch (error) {
    console.error("Server Error");
  }
};

export const fetchwhyEga = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_cmsUrl}/content-manager/ega-why-ega`,
      { headers: cmsHeaders },
    );
    return response.data.slice(-1);
  } catch (error) {
    console.error("Server Error");
  }
};

export const fetchcertificateHeader = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_strapiUrl}/api/ega-about-certificate-headers?populate=*`,
      { headers },
    );
    return response.data.data.slice(-1);
  } catch (error) {
    console.error("Server Error");
  }
};

export const fetchcertificateList = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_strapiUrl}/api/ega-about-certificate-lists?sort=Order%3Aasc&populate=*`,
      { headers },
    );
    return response.data.data.slice(0, 4);
  } catch (error) {
    console.error("Server Error");
  }
};

export const fetchjoincommunitiesHeader = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_cmsUrl}/content-manager/ega-join-community-header`,
      { headers: cmsHeaders },
    );
    return response.data.slice(-1);
  } catch (error) {
    console.error("Server Error");
  }
};
